import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 26, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, sub, align = "center" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""} mb-12 md:mb-16`}>
    <Reveal>
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-electric mb-3">{overline}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-4 text-base text-slate-500 leading-relaxed">{sub}</p>
      </Reveal>
    )}
  </div>
);
